import React from 'react';
import GracePeriodDialog from "./GracePeriodDialog";
import DefectsEliminatedDialog from "./DefectsEliminatedDialog";
import RenderPdfDialog from "./RenderPdfDialog";

export default ( props  => {

    return (
        <React.Fragment>
            {props.type && props.type === 'grace_period' && (
                <GracePeriodDialog {...props} />
            )}
            {props.type && props.type === 'defect_eliminated' && (
                <DefectsEliminatedDialog {...props} />
            )}
            {props.type && props.type === 'render_pdf' && (
                <RenderPdfDialog {...props} />
            )}
        </React.Fragment>
    );
});
